import React, { useEffect, useRef, useState } from 'react';
import { IMaskInput } from 'react-imask';
import { useField } from '@unform/core';

const InputMaskDynamic = ({ name, className, ...rest }) => {
  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);

  const [inputValue, setInputValue] = useState('');

  // Sempre que o defaultValue mudar, atualizar o input
  useEffect(() => {
    if (defaultValue) {
      setInputValue(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: () => inputValue,
      setValue: (ref, value) => {
        setInputValue(value || '');
      },
      clearValue: () => {
        setInputValue('');
      },
    });
  }, [fieldName, registerField, inputValue]);

  const masks = [
    { mask: '000.000.000-00' }, // CPF
    { mask: '00.000.000/0000-00' }, // CNPJ
  ];

  const dispatch = (appended, dynamicMasked) => {
    const number = (dynamicMasked.value + appended).replace(/\D/g, '');
    return dynamicMasked.compiledMasks[number.length > 11 ? 1 : 0];
  };

  return (
    <>
      <IMaskInput
        inputRef={inputRef}
        value={inputValue}
        mask={masks}
        dispatch={dispatch}
        className={`form-control ${className} ${error && 'border-danger'}`}
        onFocus={clearError}
        onAccept={value => setInputValue(value)} // Captura mudanças
        {...rest}
      />
      {error && <span className="text-danger">{error}</span>}
    </>
  );
};

export default InputMaskDynamic;
